export enum CONTRACT_DETAILS_TILE_MODE {
  'CHANGE_CONTRACT' = 'CHANGE_CONTRACT',
  'CANCEL_CONTRACT' = 'CANCEL_CONTRACT'
}
